export default __webpack_public_path__ + "static/media/promiseBreaker.35bd5b79.jpg";